'use strict';

var ChartPricingDepartureDatesLegendDirective = function ChartPricingDepartureDatesLegendDirective(legendFilterService) {
  return {
    restrict: 'E',
    template: require('../templates/chart-pricing-departure-dates-legend.html'),
    controller: 'ChartPricingDepartureDatesLegendController',
    scope: {},
    link: function link(scope) {
      scope.$on('Chart:departureDates:reloadFilters', function () {
        scope.reloadFilters();
      });
      scope.$on('search-criteria:searchChangeEvent', function () {
        legendFilterService.reset();
        scope.reloadFilters();
      });
    }
  };
};
ChartPricingDepartureDatesLegendDirective.$inject = ['PricingDepartureDatesLegendFilterService'];
module.exports = ChartPricingDepartureDatesLegendDirective;